<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
   <w-form ref="zform" v-model="valid" v-model:errors-count="errorsCount" @submit.prevent="validateForm" @success="success">
   <z-page :title="title">
    <div class="w-card__content content-hardcode">
        <div class="w-flex wrap smd-column" >
        <div class="grow " >
        <span style="color: black"><h1> Maklumat Program Khas</h1></span>
        <w-input class="mt4" outline label="Nama Program*"  v-model="form.nama_program" :validators="[validators.required]"/>
        <w-input class="mt4"  label="Tarikh Program Dari *" type="date" :max="tarikh_today" v-model="form.tarikh_program_dari" outline  :validators="[validators.required]"/>  
        <w-input class="mt4"  label="Tarikh Program Hingga *" type="date" :min="tarikh_today" v-model="form.tarikh_program_hingga" outline  :validators="[validators.required]"/> 
        <w-input class="mt4"  label="Masa Program *" type="time" v-model="form.waktu_program" outline :validators="[validators.required]" /> 
        </div>
        <div class="mx2"></div>
        <div class="grow " >

        <w-input class="mt8" outline label="Nama Premis *"  v-model="form.nama_premis" :validators="[validators.required]"/>
        <w-input class="mt4" outline label="Lokasi *"  v-model="form.lokasi" :validators="[validators.required]"/>
        <!-- <z-select class="mt4" outline :items="premis" label="ID / Nama Premis *"  v-model="form.premis_id"  :validators="[validators.required]"/>  -->
        <w-select
              class="mt4"
              outline
              label="Nama Pegawai Terlibat *"
              :items="juruteknik_list"
              v-model="form.juruteknik_id"
              :validators="[validators.required]"
              readonly
              @click="Jurus(form)"
            >
              <template #append>
                <w-icon 
                  class="cursor-pointer" 
                  @click.stop="Jurus(form)"
                >
                  fal fa-search
                </w-icon>
              </template>
            </w-select>


            <div v-if="pilih_jurutekni.length" class="mt3 flex flex-wrap gap-2">
              <div
                v-for="(dt, index) in pilih_jurutekni"
                :key="index"
                class="bg-primary text-white px-3 py-1 rounded-full flex items-center shadow-sm"
              >
                <span class="mr-2 text-sm">{{ index + 1 }}. {{ dt.label }}</span>
              </div>
            </div>

            
           <!-- <div v-if="form.pegawai && form.pegawai.length" class="mt3 flex justify-end">
              <ol class="list-decimal pl-8 space-y-1">
                <li v-for="(pegawai, idx) in form.pegawai" :key="idx">
                  {{ pegawai.nama_pegawai }}
                </li>
              </ol>
            </div> -->

      </div>
    </div>
  </div>
  <br>
  <div class="w-card__content content-hardcode">
        <div class="w-flex wrap smd-column">
          <div class="grow">
            <span style="color: black">
              <h1>Hasil Selepas Program Khas</h1>
            </span>
            <w-input
              class="mt4"
              outline
              label="Jumlah Ternakan Diperiksa*"
              type="number"
              v-model="form.jumlah_periksa"
              :validators="[validators.required]"
              @input="kiraTidakBunting"
            />
            <w-input
              class="mt4"
              outline
              label="Jumlah Ternakan Lulus*"
              type="number"
              v-model="form.jumlah_lulus"
              :max="form.jumlah_periksa"
              :validators="[allowZeroRequired]"
              @input="kiraTidakBunting"
            />
          </div>
          <div class="mx2"></div>

          <div class="grow">
            <w-input
              class="mt8"
              outline
              label="Jumlah Ternakan Gagal*"
              type="number"
              v-model="form.jumlah_gagal"
              disabled
            />

            
            <div class="mt6">
              <w-input class="mt4" type="file" :preview="false" accept="application/pdf, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" v-model="files_dokumen">Muat Naik Fail (PDF / Excel)</w-input>
                <!-- <div v-for="(dt, ind) in form.lampiran" :key="dt.id" class="fw-normal my1 fs-1">
                    <a :href="dt.file_url" target="_blank">{{ dt.name }}</a>
                    <w-button bg-color="error-dark1" @click="deletelAttahecment(dt.id)">
                      <w-icon xs>fal fa-trash</w-icon>
                    </w-button>
                  </div> -->

              <template v-if="form.id && form.lampiran && form.lampiran.length > 0">
                <template v-for="(dt, ind) in form.lampiran" :key="dt.id">
                  <div class="fw-normal my1 fs-1">
                    <a :href="dt.file_url" target="_blank">
                      {{ dt.name }}
                    </a>
                  </div>
                </template>
              </template>

            </div>
          </div>
        </div>
      </div>
      <w-flex class="mt3" wrap align-center justify-end v-if="$zutil.anyRole(['4'])">
       <!-- <w-button class="my1" :loading="form.submitted && !form.sent" @click="send(2); onSuccess()">
            <w-icon dark tile class="mr2">fal fa-save</w-icon> SIMPAN
       </w-button> -->
       <w-button 
        class="my1" 
        :loading="form.submitted && !form.sent"
        @click="send(2); validateForm()"
      >
        <w-icon dark tile class="mr2">fal fa-save</w-icon> 
        SIMPAN
      </w-button>
     &nbsp;
        <w-button class="my1" bg-color="success" type="submit" :disabled="form.valid === false" :loading="form.submitted && !form.sent" @click="send(1)"> 
          <w-icon xs class="mr2">fal fa-paper-plane</w-icon> HANTAR
       </w-button>
      </w-flex>
      <div class="mt2 text-left">
        <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="tutup">TUTUP</w-button>&nbsp;
      </div>
 </z-page>
    </w-form>
        <w-dialog
          v-model="dialog.show"
          :fullscreen="dialog.fullscreen"
          width="800"
          :persistent="dialog.persistent"
          :persistent-no-animation="dialog.persistentNoAnimation"
          title-class="primary-dark1--bg white">
          <template #title>
              <w-icon class="mr2">fal fa-search</w-icon>
              CARIAN PEGAWAI
          </template>
          
          <!-- Form Carian -->
          <div class="w-card mb4">
              <div class="w-card__content">
                  <div class="w-flex wrap gap-3">
                      <!-- Negeri -->
                      <div class="grow">
                          <z-select
                              outline
                              label="Negeri"
                              :items="lkp_negeri"
                              v-model="carian_juru.lkp_negeri_id"
                              item-value="value"
                              item-text="label"
                              placeholder="Pilih Negeri"
                              clearable
                          ></z-select>
                      </div>
                      
                      <!-- Nama Pegawai -->
                      <div class="grow mt2">
                          <w-input 
                              label="Nama Pegawai" 
                              v-model="carian_juru.q"
                              placeholder="Taip minimum 2 aksara"
                              clearable
                          >
                              <template #prepend>
                                  <w-icon>fal fa-user</w-icon>
                              </template>
                          </w-input>
                      </div>
                  </div>
                  
                  <!-- Butang Actions -->
                  <div class="w-flex justify-end wrap gap-2 mt4">
                      <w-button 
                          @click="getJuruteknik(form)"
                          bg-color="primary"
                          class="px-4"
                      >
                          <w-icon class="mr1">fal fa-search</w-icon>
                          Cari
                      </w-button>
                      <w-button 
                          @click="resetCarianPegawai"
                          bg-color="warning"
                          text-color="dark"
                          outline
                      >
                          <w-icon class="mr1">fal fa-undo-alt</w-icon>
                          Reset
                      </w-button>
                      <w-button 
                          @click="tambahPrfile()"
                          bg-color="success"
                      >
                          <w-icon class="mr1">fal fa-plus</w-icon>
                          Tambah
                      </w-button>
                  </div>
              </div>
          </div>

          <!-- Senarai Pegawai -->
          <div class="w-flex justify-between items-center mb2">
              <div class="fs-2 fw-bold text-primary">
                  <w-icon class="mr1">fal fa-users</w-icon>
                  Senarai Pegawai
              </div>
              &nbsp;
              <div class="text-muted fs-small">
                  Jumlah: {{ juruteknik_list.length }} rekod
              </div>
          </div>
          
          <div class="w-table-wrap" style="max-height: 400px;">
              <div class="table-profil-scrol">
                  <table class="w-table w-table--bordered">
                      <thead class="sticky-thead">
                          <tr>
                              <th class="w-table__header text-left" style="width: 50px">No</th>
                              <th class="w-table__header text-left">Nama Pegawai</th>
                              <th class="w-table__header text-left">Jenis Pengguna</th>
                              <th class="w-table__header text-center" style="width: 80px">Pilih</th>
                          </tr>
                      </thead>
                      <tbody>
                          <tr v-if="juruteknik_list.length === 0">
                              <td colspan="4" class="w-table__cell text-center py-4 text-muted">
                                  <w-icon class="mr1">fal fa-info-circle</w-icon>
                                  Tiada rekod pegawai ditemui
                              </td>
                          </tr>
                          <tr v-for="(dt, index) in juruteknik_list" :key="dt.value">
                              <td class="w-table__cell text-left">{{ index + 1 }}</td>
                              <td class="w-table__cell">
                                  <div class="fw-bold">{{ dt.label }}</div>
                                  <!-- <div class="fs-small text-muted" v-if="dt.no_id">ID: {{ dt.no_id }}</div> -->
                              </td>
                              <td class="w-table__cell">
                                  
                                      {{ dt.jenis_pengguna || '-' }}
                              </td>
                              <td class="w-table__cell text-center">
                                  <w-checkbox 
                                      class="mr2" 
                                      v-model="dt.pilih"
                                      :true-value="true"
                                      :false-value="false"
                                  >
                                  </w-checkbox>
                              </td>
                          </tr>
                      </tbody>
                  </table>
              </div>
          </div>
          
          
          <template #actions>
              <div class="w-flex justify-end items-center w-full gap-2">
                  <w-button 
                      style="background-color: #f0f0f0; border: 2px solid red; color: #333; padding: 7px 14px; border-radius: 4px;" 
                      @click="dialog.show = false"
                  >
                      <!-- <w-icon class="mr1">fal fa-times</w-icon> -->
                      TUTUP
                  </w-button>
                  <w-button 
                      bg-color="primary" 
                      @click="pilih"
                      :disabled="juruteknik_list.filter(dt => dt.pilih).length === 0"
                  >
                      <w-icon class="mr1">fal fa-save</w-icon>
                      SIMPAN ({{ juruteknik_list.filter(dt => dt.pilih).length }})
                  </w-button>
              </div>
          </template>
      </w-dialog>
    <w-dialog
     v-model="dialog_add.show"
     :fullscreen="dialog_add.fullscreen"
     :width="dialog_add.width"
     :persistent="dialog_add.persistent"
     :persistent-no-animation="dialog_add.persistentNoAnimation"
     title-class="primary-dark1--bg white">
     <template #title>
       <w-icon class="mr2">fal fa-cog</w-icon>
       Tambah Pegawai
     </template>

     <w-form 
       ref="form_add"
       v-model="dialog_add.valid"
       @validate="submitProfil"
       @success="success"
     >
       <div class="spacer"></div>
       <w-flex wrap :gap="2">
         <div class="grow mb4" style="min-width: 200px">
           <div class="input-cell">
              <w-radios
                v-model="form_profil.lkp_jenis_pengguna_id"
                 @input="getCapaian(2)"
                class="mt3"
                :items="jenis_pengguna"
                inline
                :validators="[validators.required]"
              />
            </div>
            <div class="spacer"></div>
           <br>
           <w-input
             outline
             label="No. Kad Pengenalan *"
             class="mt3"
             type="text"
             placeholder="No. Kad Pengenalan"
             name="no_id"
             v-model="form_profil.no_id"
             :validators="[validators.required]"
           />
           <div class="spacer"></div>
           <br>
           <w-input
             outline
             label="Emel *"
             class="mt3"
             type="email"
             placeholder="Sila Masukkan Emel"
             name="email"
             v-model="form_profil.email"
             :validators="[validators.required, validators.email]"
           />
           <z-select 
             outline
             class="mt4"
             :items="lkp_negeri" 
             label="Negeri *"  
             v-model="form_profil.lkp_negeri_id"
             :validators="[validators.required]"
           />
         </div>
         <div class="grow mb4" style="min-width: 200px">
           <z-select
                 outline
                 v-model="form_profil.role_id"
                 label="Peranan *"
                 :items="peran"
                 :validators="[validators.required]"
               />
            <div class="spacer"></div>
           <w-input
             outline
             label="Nama Penuh *"
             class="mt3"
             type="text"
             placeholder="Nama Penuh"
             name="name"
             v-model="form_profil.name"
             :validators="[validators.required]"
           />
           <div class="spacer"></div>
           <br>
           <w-input
             outline
             label="Nombor Telefon *"
             class="mt3"
             type="tel"
             placeholder="Sila Masukkan Nombor Telefon"
             name="no_tel"
             v-model="form_profil.no_tel"
             :validators="[validators.required, validators.numeric]"
           />
         </div>
       </w-flex>
     </w-form>
     
     <template #actions>
       <div class="spacer" />
       <w-button 
         style="
           background-color: #f0f0f0; 
           border: 2px solid red; 
           color: #333; 
           padding: 7px 14px; 
           font-size: 11px; 
           font-weight: bold; 
           border-radius: 4px; 
           cursor: pointer;
         " 
         @click="dialog_add.show = false"
       >
         TUTUP
       </w-button>
       <w-button 
         class="ml1" 
         :loading="dialog_add.loading"
         :disabled="dialog_add.valid === false"
         @click="$refs.form_add.validate()" 
       >
         SIMPAN
       </w-button>
     </template>
   </w-dialog>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    id: [Array, Object],
    d_form: [Array, Object],
    d_lkp_negeri: [Array, Object]
  

  },
  data() {
    return {
      resourceurl: 'program.program_bse',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Permohonan', route: '/program' },
        { label: 'Program Khas BSE', route: '/program/permohonan' },
        { label: 'Form', route: '/program/permohonan' },
      ],
      title : 'PD  Permohonan',
      form : this.d_form,
      lkp_negeri : this.d_lkp_negeri,
      pasung_list:[
        {value: 1, label: "Ada"},
        {value: 2, label: "Tiada"},
      ],
      dialog_add: {
         valid: false,
         show: false,
         fullscreen: false,
         persistent: true,
         persistentNoAnimation: false,
         loading: false,
         width: 800,
         item: {name: '', email: '', mobile: ''}
      },
      negeri:'',
      files_dokumen:[],
      ternakan_list:[],
      attahecment:[],
      premis : [],
      jenis_pengguna : [],
      peran : [],
      juruteknik_list : [],
      lkp_status : [],
      lkp_art : [],
      loading : 0,
      checkin:false,
      tarikh_today: 0,
      carian_juru: {
           q: '',
           lkp_negeri_id: ''
         },
      pilih_jurutekni : [],
      load: 0,
      id: 0
    
    }
  },
  methods: {
    pilih(dt){
      this.pilih_jurutekni = [];
        for (var i in this.juruteknik_list) {
          if(this.juruteknik_list[i].pilih == true){
            this.pilih_jurutekni.push({
                  label:this.juruteknik_list[i].label,
                  id: this.juruteknik_list[i].value
                });
          }
        }
      this.dialog.show = false;
    },
    Jurus(form){
        this.getJuruteknik();
        this.dialog.show = true;
        this.form.saveButton = "Simpan"
      
    },

    send(hantar){
      this.form.hantar = hantar
    },

    resetCarianPegawai() {
          
          this.carian_juru = {
              q: '',
              lkp_negeri_id: ''
          };
          
          
          this.getJuruteknik();
          
         
          this.$zutil.notify("Carian telah direset", true);
      },


    // kiraTidakBunting() {
    //     const periksa = this.form.jumlah_periksa || 0;
    //     let lulus = this.form.jumlah_lulus || 0;

        
    //     if (lulus > periksa) {
    //         lulus = periksa;
    //         this.form.jumlah_lulus = lulus;
    //     }

    //     this.form.jumlah_gagal = periksa - lulus;
    // },

    kiraTidakBunting() {
     const periksa = Number(this.form.jumlah_periksa) || 0;
     let lulus = Number(this.form.jumlah_lulus) || 0;

     if (lulus < 0) lulus = 0;
     if (lulus > periksa) lulus = periksa;

     this.form.jumlah_lulus = lulus;
     this.form.jumlah_gagal = periksa - lulus;
   },

    submitProfil() {
        this.dialog_add.loading = true;

        this.$zcomm.post('pegawai', this.form_profil)
          .then(res => {

            if (
              typeof res === "string" &&
              (res.includes("No. Kad Pengenalan sudah wujud!") ||
               res.includes("Email sudah wujud!"))
            ) {
              if (res.includes("No. Kad Pengenalan sudah wujud!")) {
                this.$zutil.notify("No. Kad Pengenalan sudah wujud!", false);
              }
              if (res.includes("Email sudah wujud!")) {
                this.$zutil.notify("Email sudah wujud!", false);
              }
              return;
            }

            
            if (!res || !res.id) {
              this.$zutil.notify("Ralat: Data tidak disimpan dengan betul", false);
              return;
            }

            this.$zutil.notify("Berjaya disimpan");

            
            const jenisPengguna =
              res.jenis_pengguna ||
              this.jenis_pengguna.find(
                j => j.value === this.form_profil.lkp_jenis_pengguna_id
              )?.label ||
              '-';

            
            const newPegawai = {
              value: res.id,
              label: res.name || this.form_profil.name,
              lkp_jenis_pengguna_id: this.form_profil.lkp_jenis_pengguna_id,
              jenis_pengguna: jenisPengguna,
              no_id: this.form_profil.no_id,
              email: this.form_profil.email,
              no_tel: this.form_profil.no_tel,
              pilih: true
            };

            
            this.juruteknik_list.unshift(newPegawai);

            
            this.pilih_jurutekni.push({
              id: newPegawai.value,
              label: newPegawai.label,
              jenis_pengguna: newPegawai.jenis_pengguna
            });

            
            this.dialog_add.show = false;
          })
          .catch(err => {
            console.error('Error saving user:', err);
            this.$zutil.notify("Ralat semasa menyimpan data", false);
          })
          .finally(() => {
            this.dialog_add.loading = false;
          });
      },

   getlkpJenisPengguna(){
            this.$zcomm.get(this.api_service + 'lookup/jenis_pengguna', {}).then(res => {
              this.jenis_pengguna = res
            })
        },

  getCapaian(id){
         if(this.form_profil.role_id != null || this.form_profil.role_id != ''){
            this.form_profil.role_id = null;
         }
         if (id==2) {
            this.form_profil.role_id = '';
            this.form_profil.lkp_bandar_id = '';
            this.form_profil.lkp_poskod_id = '';
            this.form_profil.lkp_daerah_id = '';
            this.form_profil.lkp_cawangan_id = '';
            this.form_profil.poskod = '';
            this.form_profil.lkp_negara_id='';
            this.form_profil.alamat = '';
            this.form_profil.warga_negara = '';
            this.form_profil.no_siri='';
            this.form_profil.tarikh_lantikan='';
            this.form_profil.kategori_user = '';
         }
         this.$zcomm.get(this.api_service + 'lookup/capaian-register/'+this.form_profil.lkp_jenis_pengguna_id, {}).then(res => {
           this.peran = res
         })
     },

   tambahPrfile(){
        this.form_profil = {
          id: null,
          no_id: null,
          name: null,
          email: '',
          no_tel: '',
          alamat: '',
          role_id: '',
          lkp_jenis_pengguna_id: '',
          password: 123123,
          pembekal: null,
          status: 1,
          kode: '',
          lkp_poskod_id: '',
          lkp_bandar_id: '',
          lkp_negeri_id: '',
          operator: 1
        };
        
        this.dialog_add.valid = false;
        
        // Buka dialog
        this.dialog_add.show = true;
      },

    pengguna(){
      this.getUserList();
      this.dialog.show = true
      this.form.saveButton = "Save"
    },


    validateForm() {
      this.loading = true;
      let errors = [];

      
      if (this.pilih_jurutekni && this.pilih_jurutekni.length > 0) {
        this.form.pegawai = this.pilih_jurutekni.map(dt => ({
          nama_pegawai: dt.label,
          id: dt.id
        }));
      } else {
        
        this.form.pegawai = this.form.pegawai && this.form.pegawai.length > 0 
          ? this.form.pegawai 
          : [];
      }

      
      if (
        !this.form.nama_program ||
        !this.form.tarikh_program_dari ||
        !this.form.tarikh_program_hingga ||
        !this.form.waktu_program ||
        !this.form.nama_premis ||
        !this.form.lokasi ||
        !(this.form.juruteknik_id || this.form.pegawai?.length > 0) || 
        this.form.jumlah_periksa === null ||
        this.form.jumlah_lulus === null ||
        this.form.jumlah_gagal === null 
      ) {
        errors.push("Pastikan semua data sudah diisi.");
      }

      
      if (!this.form.pegawai || this.form.pegawai.length === 0) {
        errors.push("Sila pilih sekurang-kurangnya seorang pegawai terlibat.");
      }

      
      if (
        (!this.files_dokumen || this.files_dokumen.length === 0) &&
        (!this.form.lampiran || this.form.lampiran.length === 0)
      ) {
        errors.push("Sila muat naik fail PDF atau Excel.");
      } else {
        
        const maxSize = 10 * 1024 * 1024; 
        if (this.files_dokumen && this.files_dokumen.length > 0) {
          for (let fileObj of this.files_dokumen) {
            const file = fileObj.file || fileObj;
            if (file.size > maxSize) {
              errors.push(`Fail "${file.name}" melebihi saiz maksimum 10MB.`);
            }
          }
          this.form.lampiran = this.files_dokumen[0];
        }
      }

      if (errors.length > 0) {
        this.$zutil.notify(errors.join("\n"), false);
        this.loading = false;
        return false;
      }

      this.onSuccess();
    },



    klickPilih(){
        for (var b in this.ternakan_list) {
            this.ternakan_list[b].pilih = this.checkin
        }
    },


    onSuccess(){
      this.form.tujuan_program_id = 2;
      this.form.permohonan = 1;
      this.form.juruteknik_id = this.pilih_jurutekni? this.pilih_jurutekni : [];
      if(this.form.hantar == 1){
        this.$swal({
            title: 'Anda Pasti?',
            // text: "Are you sure want to delete this item!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya',
            cancelButtonText: 'Tidak'
          }).then((result) => {
            if (result.value) {
              if (this.form.id > 0){
                this.$zcomm.update(this.resourceurl + '.update', this.form.id, this.form)
                .then(res => {
                  if (typeof this.onAfterEdit === "function") {
                    this.onAfterEdit()
                  }
                  if (this.files_dokumen.length > 0) {
                      this.uploadPDFDokumen(res.id);
                   }
                  if (this.form.hantar==1) {
                    this.$inertia.visit(this.$route('program.program_bse.index'));
                  }else{
                      this.$zutil.notify("Berjaya disimpan", true);
                  }
                  // this.$inertia.visit(this.$route('se.pemungutan.show', this.form.id))
                })
              }else{
                this.$zcomm.post(this.resourceurl+'.store' , this.form)
                .then(res => {
                  if (typeof this.onAfterAdd === "function") {
                    this.onAfterAdd()
                  }
                  if (this.files_dokumen.length > 0) {
                      this.uploadPDFDokumen(res.id);
                   }
                  this.$zutil.notify("Berjaya dihantar", true);
                  this.$inertia.visit(window.route('program.program_bse.index'));

                })
              }
            }
          })
      }else{
        if (this.form.id > 0) 
        {
          
          this.$zcomm.update(this.resourceurl + '.update', this.form.id, this.form)
          .then(res => {
            if (typeof this.onAfterEdit === "function") {
              this.onAfterEdit()
            }
            if (this.files_dokumen.length > 0) {
                  this.uploadPDFDokumen(res.id);
               }
            if (this.form.hantar==1) {
                this.$inertia.visit(this.$route('program.program_bse.index'));
            }else{
                this.$zutil.notify("Berjaya disimpan", true);
                this.$inertia.visit(this.$route('program.program_bse.index', this.form.id));
            }
            // this.$inertia.visit(this.$route('se.pemungutan.show', this.form.id))
          })
        }
        else 
        {
          this.$zcomm.post(this.resourceurl+'.store' , this.form)
          .then(res => {
            if (typeof this.onAfterAdd === "function") {
              this.onAfterAdd()
            }
            if (this.files_dokumen.length > 0) {
                  this.uploadPDFDokumen(res.id);
               }
            this.$zutil.notify("Berjaya disimpan", true);
            this.$inertia.visit(this.$route('program.program_bse.index', res.id));

          })
        }
      } 
      
    },

    uploadPDFDokumen(item) 
    {  
       let formData = new FormData();
       for (var b in this.files_dokumen) 
       {
           formData.append("files["+b+"]", this.files_dokumen[b].file);
       }
       formData.append("model",'\\App\\Model\\ProgramDokumen');
       formData.append("model_id", item);
       this.$zcomm.post('attahecment.upload_replace', formData)
           .then((res) => {
               this.getAttahecmentDokumen();
               this.loadData();
               this.files_dokumen = [];
           })
           .catch((err) => {})
           .finally(() => {});
   },

   getAttahecmentDokumen(item)
    {
      this.$zcomm.get(this.api_service + 'attahecment/list', {model_id : item, model : '\\App\\Model\\ProgramDokumen'}).then(res => {
         this.form.lampiran = res.data; 
      })
    },

   deletelAttahecment(id) {
      this.$swal({
        title: 'Anda Pasti?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ya',
        cancelButtonText: 'Tidak'
      }).then((result) => {
        if (result.value) {
          this.$zcomm.delete(this.resourceurl + '.destroy_program', id)
            .then(res => {
              this.form.lampiran = this.form.lampiran.filter(item => item.id !== id)
              this.$zutil.notify("Lampiran berhasil dihapus", true)
            })
        }
      })
    },


    getPremis(){
      this.$zcomm.get(this.api_service + 'lookup/premis', {}).then(res => {
        this.premis = res
        if (this.premis.length == 1) {
         for (var p in this.premis) {
            this.form.premis_id = this.premis[p].value;
            this.form.lkp_negeri_id = this.premis[p].lkp_negeri_id;
            this.form.lkp_negeri = this.premis[p].lkp_negeri;
         }
        }
      })
    },

    // getData(){
    //   this.getJuruteknik(this.d_form);
    // },

    

    getJuruteknik(){
        this.$zcomm.get(this.api_service + 'lookup/juruteknik_program', this.carian_juru, {})
          .then(res => {
            this.juruteknik_list = res.map(pegawai => {
               const isSelected = this.pilih_jurutekni.find(pilih => pilih.id === pegawai.value);
               return {
                 ...pegawai, 
                 pilih: !!isSelected // Jika ditemukan, isSelected akan berisi objek, jadi konversikan menjadi true. Jika tidak, akan menjadi false.
               };
             });
            // this.juruteknik_list = res
          })
      },


    getJenisTernakan(){
         this.$zcomm.get(this.api_service + 'lookup/ternakan', {}).then(res => {
           this.lkp_ternakan = res
         })
       },

    
  
    tutup(){
         this.$inertia.visit(window.route('program.program_bse.index'));
       },


  
  },

  watch: {

  },
  mounted() {
  
    this.pilih_jurutekni = this.d_form.pilih_jurutekni;
    var today = new Date();
    this.tarikh_today = today.toISOString().split('T')[0];
    if(this.id > 0)
    {
      this.title = 'Tambah Permohonan Perkhidmatan Pemeriksaan Dayabiak (BSE)'
    }
    else
    {
      this.title = 'Tambah Permohonan Perkhidmatan Pemeriksaan Dayabiak (BSE)'
    }
    this.getPremis()
    this.getJenisTernakan()
    this.getJuruteknik()
    this.getlkpJenisPengguna()
    // this.getTernakanList()
  }
    
}
</script>
<style scoped>
   
/*.input-cell {
  display: flex;
  flex-direction: column;
}

.sticky-thead {
  position: sticky;
  top: 0;
  z-index: 10;
  background-color: #f5f5f5; 
}*/

.input-cell {
    display: flex;
    flex-direction: column;
}

.sticky-thead {
    position: sticky;
    top: 0;
    z-index: 10;
    background-color: #f5f5f5;
}

/* Untuk gap yang lebih konsisten */
.gap-2 {
    gap: 0.5rem;
}

.gap-3 {
    gap: 1rem;
}

.gap-4 {
    gap: 1.5rem;
}

.px-4 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
}

.py-4 {
    padding-top: 2rem;
    padding-bottom: 2rem;
}

.mb4 {
    margin-bottom: 1rem;
}

.mt4 {
    margin-top: 1rem;
}

.fs-small {
    font-size: 0.75rem;
}

.fs-2 {
    font-size: 1.1rem;
}

.fw-bold {
    font-weight: 600;
}

.text-muted {
    color: #6c757d;
}

.text-primary {
    color: #007bff;
}

.text-center {
    text-align: center;
}

.w-table--bordered {
    border: 1px solid #dee2e6;
}

.w-table--bordered th,
.w-table--bordered td {
    border: 1px solid #dee2e6;
}
</style>

